import React, { useState, useRef } from 'react';
import clsx from 'clsx';
import Spinner from "../common/spinner";
import ErrorComponent from "../components/UI/error";
import SuccessComponent from "../components/UI/success";
import Global from '../common/global';

import PhoneInput from 'react-phone-input-2'

function Input({languages, inputFields, inputChange, inputPhoneChange, taxNumberIN, onFieldBlur, inputEl, locationData, emailChecking}) {
return (
    <>
    {
        inputFields.map((item, index) => {
        var ItemIcon = item.icon;
        const { 
            name,
            type,
            maxLength,
            minLength,
            options,
            placeholder,
            required,
            value,
            message,
            isError,
            valid,
            checking,
            disabledChecker,
            // valFunction
        } = item
        return (
            <React.Fragment key={index}>
                <div className="input-fields flex items-center mb-2" >   
                    <label htmlFor="simple-search" className="sr-only">  </label>
                    <div className={clsx("relative w-full", {
                        // 'disabled-input': checking === undefined ? true : false
                    })}>
                        <div className="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
                            
                            {
                                // type !== 'tel' &&
                                <ItemIcon />
                            }
                        </div>
                        
                        {
                            type === 'select' ? (
                            <select 
                                name={name} 
                                onChange={inputChange}
                                defaultValue={value}
                                className={clsx('input input-select font-montsterrat bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#0c0455] focus:border-[#0c0455] block w-full dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white', {
                                    'valid-field '   : valid ? true : false,
                                    'invalid-field ' : isError ? true : false,
                                })} > 
                                    <option value="" disabled selected>{placeholder}</option>
                                    {
                                        options.map((opt, index) => {
                                            return (
                                            <option className="p-0"  key={index} value={opt.value} selected={opt.value === value ? true : false}>
                                                {opt.text}
                                            </option>
                                            )
                                        })
                                    }
                            </select>
                            ) :
                            type === 'tel' ? (                                
                                <PhoneInput
                                    autoFormat={true}
                                    inputProps = {{
                                        name      : 'phone',
                                        required  : true,
                                        autoFocus : true
                                    }}
                                    enableSearch = {true}
                                    disableSearchIcon = {true}
                                    inputClass = {'input input-phone font-montsterrat bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#0c0455] focus:border-[#0c0455] block w-full dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white'}
                                    country    = {locationData.country === 'EN' ? 'us' : locationData.country.toLowerCase()}
                                    value      = {value.inputVal}
                                    onChange   = {(e, name) => inputPhoneChange(e, name)}
                           
                                />
                            ) : (
                            <input 
                                maxLength    = {maxLength}
                                minLength    = {minLength}
                                key          = {name}
                                ref          = {el => inputEl.current[name] = el}
                                type         = {type} 
                                name         = {name}
                                placeholder  = {placeholder} 
                                // placeholder  = {languages}
                                value        = {value}
                                onChange     = {inputChange}
                                onBlur       = {onFieldBlur}
                                disabled     = {emailChecking ? true : false}
                                autoComplete = "off"
                                className    = {clsx(`input bg-gray-50 font-montsterrat border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#0c0455] focus:border-[#0c0455] block w-full dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white`,
                                {
                                    'valid-field '   : valid ? true : false,
                                    'invalid-field ' : isError ? true : false,
                                })}
                                required={required}                 
                            />
                            )
                        }
                    </div>
                </div>
                <div className="mb-2" key={'validation' + index}> 
                    {checking && (
                        <Spinner message={type == 'email' ? (languages.emailCheck ? languages.emailCheck :'Checking Email Address'): 'Checking'}/>
                    )} 
                    {isError && !valid && message && !checking && (
                        <ErrorComponent errorMessage={message}/>
                    )}

                    {valid && !isError && message && !checking && (
                        <SuccessComponent message={message}/>
                    )} 
                </div>
            </React.Fragment>
        )
        })
    } 
    

    {/* {           
        taxNumberIN ? (
        locationData.country === 'au' || 'AU' && 
        
        <div className="input-fields flex items-center mb-2" >
            <input 
                placeholder='Tax Number'
                value=''
                type='num'
                // onChange={inputChange}
                className='input bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#0c0455] focus:border-[#0c0455] block w-full pl-10 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white'
                required              
            />
        </div> ) 
        : <> </> 
    } */}
    </>
)
}

export default Input
